import React from 'react';
import { Modal } from '@tvg/fuse/modal';
import { TypographyComponent } from '@tvg/fuse/typography';
import { Divider } from '@tvg/fuse/divider';
import styles from './DialogStyles.module.css';

type DialogProps = React.ComponentPropsWithoutRef<typeof Modal>;
export const Dialog = React.forwardRef<React.ElementRef<typeof Modal>, DialogProps>(({ className, ...props }, ref) => (
  <Modal ref={ref} className={[styles.dialog, className].filter(Boolean).join(' ')} {...props} />
));

Dialog.displayName = 'Dialog';

export const DialogSection = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  ({ className, ...props }, ref) => (
    <section ref={ref} className={[styles.section, className].filter(Boolean).join(' ')} {...props} />
  ),
);

DialogSection.displayName = 'DialogSection';

type TypographyProps = React.ComponentPropsWithoutRef<typeof TypographyComponent>;
export const DialogHeading = React.forwardRef<React.ElementRef<typeof TypographyComponent>, TypographyProps>(
  ({ className, ...props }, ref) => (
    <TypographyComponent ref={ref} className={[styles.heading, className].filter(Boolean).join(' ')} {...props} />
  ),
);

DialogHeading.displayName = 'DialogHeading';

export const DialogText = React.forwardRef<React.ElementRef<typeof TypographyComponent>, TypographyProps>(
  ({ className, ...props }, ref) => (
    <TypographyComponent ref={ref} className={[styles.text, className].filter(Boolean).join(' ')} {...props} />
  ),
);

DialogText.displayName = 'DialogText';

export const DialogList = React.forwardRef<HTMLUListElement, React.HTMLAttributes<HTMLUListElement>>(
  ({ className, ...props }, ref) => (
    <ul ref={ref} className={[styles.list, className].filter(Boolean).join(' ')} {...props} />
  ),
);

DialogList.displayName = 'DialogList';

type DividerProps = React.ComponentPropsWithoutRef<typeof Divider>;
export const DialogDivider = React.forwardRef<React.ElementRef<typeof Divider>, DividerProps>(
  ({ className, ...props }, ref) => (
    <Divider ref={ref} className={[styles.divider, className].filter(Boolean).join(' ')} {...props} />
  ),
);

DialogDivider.displayName = 'DialogDivider';
